import { BaseEntity } from "yt-ng-framework";

export class FakDokumentPovezaniSaKOKZ extends BaseEntity{

    constructor(){
        super();
    }    

    BrojDokumenta: string;
    DatumPrometaOd: Date;
    DatumPrometaDo: Date;

    Deserialize(input: any){
        this.BrojDokumenta = input.BrojDokumenta;
        this.DatumPrometaOd = input.DatumPrometaOd;
        this.DatumPrometaDo = input.DatumPrometaDo;
        return this;
    }

    Serialize(input: FakDokumentPovezaniSaKOKZ){
        return input;
    }
}